import { useOrganisationUnitsWithProducts } from './UseOrganisationUnitsWithProducts';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';
import { Product } from '@app/models';
import { productBaseUrl } from '../BaseUrls';
import { useGet } from '../../HttpClient';

const pillarCode = "tms";
 
export function useProductsByOuId({ ouId }: { ouId: string }) {
  const { data: ousWithProducts } = useOrganisationUnitsWithProducts();
  const get = useGet(true, pillarCode);
  const getProducts = () => get<Product[]>(`${productBaseUrl}/products`);

  return useQueryWithErrorHandling({
    queryKey: ['products-by-ou-id', ouId],
    queryFn: async () => await getProducts(),
    select: (products) => {
      const ou = ousWithProducts.find((ou) => ou.id === ouId);
      return ou.products.map((productId) => products.find((product) => product.productId === productId));
    },
    enabled: !!ouId && !!ousWithProducts,
  });
}
